"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityStatusFieldLogic = void 0;
const field_logic_1 = require("../../field-type-registry/field-logic");
const fields_1 = require("../../utils/fields");
const intl_1 = require("../../locale/intl");
const availability_status_fieldtype_1 = require("../../safe-field-value/member-fields/availability-status-field/availability-status.fieldtype");
const texts_1 = require("../../texts");
class AvailabilityStatusFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "availabilitystatusfield";
        this.label = (0, intl_1.$t)(texts_1.availabilityStatusFieldText.availability);
        this.icon = "status";
        this.placeholder = (0, intl_1.$t)(texts_1.availabilityStatusFieldText.whats_your_status);
        this.fieldValueGetter = new availability_status_fieldtype_1.AvailabilityStatusFieldValueGetter();
    }
    valueToString(record, field) {
        const fieldValue = (0, fields_1.getValueFromRecordByField)(record, field);
        return fieldValue.emoji + " " + fieldValue.status;
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
    isSupportedByBulkAction() {
        return false;
    }
}
exports.AvailabilityStatusFieldLogic = AvailabilityStatusFieldLogic;
